module.exports = __webpack_public_path__ + "img/flags/AM.4ea6eb5.png";